export const SET_COMPANY_BY_RUT = 'bajas/SET_COMPANY_BY_RUT';
export const SET_INSURANCE_COMPANY_BY_RUT =
  'bajas/SET_INSURANCE_COMPANY_BY_RUT';
export const SET_POLICY_INSURANCE_COMPANY =
  'bajas/SET_POLICY_INSURANCE_COMPANY';
export const SET_BAJA_MASIVA = 'bajas/SET_BAJA_MASIVA';
export const SET_BAJA_INDIVIDUAL = 'bajas/SET_BAJA_INDIVIDUAL';

export const GET_COMPANY_BY_RUT = 'bajas/GET_COMPANY_BY_RUT';
export const GET_BAJA_MASIVA = 'bajas/GET_BAJA_MASIVA';
export const GET_BAJA_INDIVIDUAL = 'bajas/GET_BAJA_INDIVIDUAL';

export const FETCH_COMPANY_BY_RUT = 'bajas/FETCH_COMPANY_BY_RUT';
export const FETCH_INSURANCECOMPANY_BY_RUT =
  'bajas/FETCH_INSURANCECOMPANY_BY_RUT';
export const FETCH_POLICY_INSURANCE_COMPANY =
  'bajas/FETCH_POLICY_INSURANCE_COMPANY';
export const FETCH_BAJA_MASIVA = 'bajas/FETCH_BAJA_MASIVA';
export const FETCH_BAJA_INDIVIDUAL = 'bajas/FETCH_BAJA_INDIVIDUAL';
export const FETCH_BM_URL = 'bajas/FETCH_BM_URL';

export const POST_TICKET_MASSIVE_EXCLUSION =
  'bajas/POST_TICKET_MASSIVE_EXCLUSION';
export const POST_INDIVIDUAL_EXCLUSION = 'bajas/POST_INDIVIDUAL_EXCLUSION';
export const POST_CANCEL_EXCLUSION_TICKET =
  'bajas/POST_CANCEL_EXCLUSION_TICKET';
export const PATCH_FINISH_EXCLUSION_TICKET =
  'ticket/PATCH_FINISH_EXCLUSION_TICKET';
export const CANCEL_MASSIVE_EXCLUSION = 'bajas/CANCEL_MASSIVE_EXCLUSION';
export const SUCCESS_MASSIVE_EXCLUSION = 'bajas/SUCCESS_MASSIVE_EXCLUSION';
export const UPDATE_END_DATE_BEFORE_FINISH_EXCLUSION =
  'bajas/UPDATE_END_DATE_BEFORE_FINISH_EXCLUSION';

export const UPDATE_END_DATE_BEFORE_FINISH_MASSIVE_EXCLUSION =
  'bajas/UPDATE_END_DATE_BEFORE_FINISH_MASSIVE_EXCLUSION';
